import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useOnboarding } from "../../hooks/useOnboarding";
import FirmOnboardingWorkspace from "./FirmOnboardingWorkspace";
import "./GettingStarted.scss";

export default function GettingStarted() {
  const navigate = useNavigate();
  const {
    onboardingSummary: summary,
    gettingStartedError: error,
    refreshGettingStarted,
    markSetupComplete,
    launchAction,
  } = useOnboarding();
  if (summary.percentComplete >= 100)
    return (
      <Navigate
        to={summary.journey === "firm" ? "/firm/dashboard" : "/review-tasks"}
        replace
      />
    );
  if (summary.journey !== "firm")
    return (
      <main className="getting-started-page piers-page">
        <div className="firm-onboarding firm-onboarding--journey">
          <section className="firm-onboarding__journey-hero">
            <div className="piers-page-header">
              <p>WELCOME TO PIERS</p>
              <h1 className="piers-page-title">Your work, one step at a time</h1>
              <span>
                Open your assigned work and complete the responsibilities
                available to your role.
              </span>
            </div>
            <div className="firm-onboarding__journey-progress">
              <strong>{summary.percentComplete}%</strong>
              <span>
                <i style={{ width: `${summary.percentComplete}%` }} />
              </span>
              <small>
                {summary.completedCount} of {summary.totalCount} steps complete
              </small>
            </div>
          </section>
          {error && <div className="firm-onboarding__error">{error}</div>}
          <div className="firm-onboarding__journey-list">
            {summary.milestones.map((item, index) => (
              <article key={item.id} className={`is-${item.status}`}>
                <i>{item.status === "completed" ? "✓" : index + 1}</i>
                <div>
                  <span>
                    {item.status === "current" ? "UP NEXT" : "YOUR JOURNEY"}
                  </span>
                  <h2>{item.title}</h2>
                  <p>{item.detail || item.description}</p>
                </div>
                {item.action && (
                  <button
                    type="button"
                    onClick={() => launchAction(item.action, item)}
                  >
                    {item.action.label}
                  </button>
                )}
              </article>
            ))}
          </div>
        </div>
      </main>
    );

  return (
    <main className="getting-started-page getting-started-page--wizard piers-page">
      <FirmOnboardingWorkspace
        summary={summary}
        progressError={error}
        onRefresh={refreshGettingStarted}
        onComplete={markSetupComplete}
        onLaunch={launchAction}
        onFinish={(choice) =>
          navigate(choice === "no" ? "/firm/dashboard" : "/engagements/import")
        }
      />
    </main>
  );
}
